import React from 'react';

export type AlertSeverity = 'info' | 'success' | 'warning' | 'error';

interface StatusAlertProps {
  severity: AlertSeverity;
  message: string;
  onClose?: () => void;
  closeLabel: string;
}

const severitySymbols: Record<AlertSeverity, string> = {
  info: 'i',
  success: 'v',
  warning: '!',
  error: '!',
};

function StatusAlert({ severity, message, onClose, closeLabel }: StatusAlertProps): React.ReactElement {
  const role = severity === 'error' || severity === 'warning' ? 'alert' : 'status';

  return (
    <div className={`status-alert status-alert--${severity}`} role={role} aria-live="polite">
      <span className="status-alert__icon" aria-hidden="true">
        {severitySymbols[severity]}
      </span>
      <p className="status-alert__message">{message}</p>
      {onClose && (
        <button
          type="button"
          className="status-alert__close"
          aria-label={closeLabel}
          onClick={onClose}
        >
          x
        </button>
      )}
    </div>
  );
}

export default StatusAlert;
